import dashboardsClient from "./dashboardsApiClient";

export async function fetchDashboards() {
  // esperado: { count, items: [...] }
  const res = await dashboardsClient.get("/dashboards");
  return res.data;
}

export async function requestDashboardAccess(dashboardId) {
  // esperado: { url, expires_in }
  const res = await dashboardsClient.post(
    `/dashboards/${encodeURIComponent(dashboardId)}/access`
  );
  return res.data;
}
